<template>
  <div id="app">
    <!-- This is where the current route's component will be rendered -->
    <router-view />

    <!-- <footer>
      <p>© 2024 Resume Builder</p>
    </footer> -->
  </div>
</template>

<script>
import { ref, provide, onMounted, onUnmounted } from 'vue';
import store from '@/store';

const REFRESH_CHECK_INTERVAL_MS = 30 * 60 * 1000; // 30 minutes

export default {
  name: 'App',
  setup() {
    const isMobile = ref(window.innerWidth <= 768);
    let refreshCheckTimer = null;

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 768;
    };

    const checkAndRefreshToken = () => {
      if (store.getters['auth/isAuthenticated'] && store.getters['auth/isTokenExpiringSoon']) {
        store.dispatch('auth/refreshToken').catch(() => {
          store.dispatch('auth/logout');
          window.location.href = '/login';
        });
      }
    };

    onMounted(() => {
      window.addEventListener('resize', handleResize);
      if (store.getters['auth/isAuthenticated']) {
        refreshCheckTimer = setInterval(checkAndRefreshToken, REFRESH_CHECK_INTERVAL_MS);
      }
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
      if (refreshCheckTimer) clearInterval(refreshCheckTimer);
    });

    provide('isMobile', isMobile);

    return { isMobile };
  },
};
</script>

<style scoped>
/* Styling for the navigation and layout */
#app {
  font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav ul {
  display: flex;
  list-style: none;
  justify-content: center;
  padding: 0;
}

nav ul li {
  margin: 0 10px;
}

nav ul li a {
  text-decoration: none;
  color: #42b983;
}

nav ul li a.router-link-active {
  font-weight: bold;
}

footer {
  margin-top: 40px;
}
</style>
